export default __webpack_public_path__ + "static/media/factory__19.e4a73afb.jpg";